
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marismith",
      function () {
        return require("private-next-pages/marismith.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marismith"])
      });
    }
  